import { Component } from '@angular/core';
import { Role } from '../../model/auth/Role';
import { Competition } from '../../model/competition/Competition';
import { CompetitionService } from '../../service/competition.service';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { User } from '../../model/auth/User';
import { MobileAwareComponent } from '../../common/mobile-aware/mobile-aware.component';
import { NotificationHandler } from '../../helper/notification.handler';
import {
  InviteUserDetailsData,
  InviteUserModalComponent,
  InviteUserResult
} from '../../profile/invite-user-modal/invite-user-modal.component';
import {
  DeleteConfirmationData,
  DeleteConfirmationModalComponent,
  DeleteContext
} from '../../common/modal/delete-confirmation-modal/delete-confirmation-modal.component';
import { UserDetails, UsersTableComponent } from '../../profile/users-table/users-table.component';

@Component({
  selector: 'app-hosts-list',
  templateUrl: './hosts-list.component.html',
  styleUrls: ['./hosts-list.component.scss']
})
export class HostsListComponent extends MobileAwareComponent {

  readonly HOST_ROLE = Role.Host;

  readonly roles = [Role.Admin];

  inProgress = false;

  hosts!: User[] | null;
  competition!: Competition | null;

  constructor(private competitionService: CompetitionService,
              private dialog: MatDialog,
              breakpointObserver: BreakpointObserver) {
    super(breakpointObserver);
  }

  inviteHost(competition: Competition | null) {
    if (competition) {
      const data: InviteUserDetailsData = {
        competitionId: competition.id
      };
      this.inviteHostInternal(data);
    }
  }

  private inviteHostInternal(data: InviteUserDetailsData) {
    this.dialog.open(InviteUserModalComponent, {
      width: '600px',
      data: data
    }).afterClosed().subscribe((data: InviteUserResult) => {
      if (data && data.addMore && data.addMoreData) {
        if (data.user && this.hosts) {
          this.hosts.unshift(data.user);
        }
        this.inviteHostInternal(data.addMoreData);
      } else if (data && data.user && this.competition) {
        this.loadHosts(this.competition.id);
      }
    });
  }

  removeHost(details: UserDetails, usersTable: UsersTableComponent) {
    if (details.competitionId) {
      const data: DeleteConfirmationData = {
        title: $localize`:General|Remove action label@@general-remove-action-label:Remove`,
        itemType: $localize`:Hosts List|Hosts list delete item type@@hosts-list-delete-item-type:Host`,
        name: details.user.email,
        actionDesc: $localize`:Hosts List|Hosts list delete item prompt@@hosts-list-delete-item-prompt:will be removed from the competition`,
        archive: false
      };

      const dialogRef = this.dialog.open(DeleteConfirmationModalComponent, {
        width: '600px',
        data: data
      });

      dialogRef.componentInstance.deleteConfirmed.subscribe((context: DeleteContext) => {
        this.competitionService.deleteHost(details.competitionId, details.user.id).subscribe({
          next: () => {
            if (this.hosts) {
              const index = this.hosts.findIndex(host => host.id == details.user.id);
              if (index >= 0) this.hosts.splice(index, 1);

              usersTable.updateData();

              context.modal.deleteHandled();
            }
          },
          error: error => {
            context.modal.deleteHandled($localize`:Notifications|Host delete from competition has failed message@@notifications-host-delete-from-competition-failed-error:Removing host from a competition has failed`, error);
          }
        });
      });
    }
  }

  competitionSelected(competition: Competition) {
    this.competition = competition;

    this.loadHosts(competition.id);
  }

  loadHosts(competitionId: string) {
    this.inProgress = true;
    this.hosts = null;

    this.competitionService.getHosts(competitionId).subscribe({
      next: hosts => {
        this.hosts = hosts;
        this.inProgress = false;
      },
      error: error => {
        this.inProgress = false;
        NotificationHandler.handleError($localize`:Notifications|Competition hosts fetch has failed message@@notifications-competition-hosts-fetch-failed-error:Competition hosts fetch has failed`, error);
      }
    });
  }

  handleUpdatedUser(user: User) {
    if (this.hosts) {
      const oldUser = this.hosts.find(u => u.id == user.id);
      if (oldUser) oldUser.contactPerson = user.contactPerson;
    }
  }
}
